import React from "react";

import { Link } from "@hdir/ui/link";
import { Chip } from "@hdir/ui/chip";
import { faArrowRight, faArrowUpRightFromSquare } from "@fortawesome/pro-light-svg-icons";
import { Card } from "@hdir/ui/card";
import type { LinkElement } from "@dip/helsecore/src/types/LinkElement";
import FontAwesomeIconWrapper from "../../FontAwesomeIconWrapper/FontAwesomeIconWrapper";

const CARD_BORDER_CLASSES = "border border-action-primary rounded-sm";
const CARD_STYLE_CLASSES = "min-w-full h-full flex flex-col padding-lg";

export type StatisticsCardBaseProps = {
  link?: LinkElement;
  source?: string;
  children?: React.ReactNode;
};

export default function Base(props: Readonly<StatisticsCardBaseProps>) {
  const {
    link,
    source,
    children
  } = props;

  const hasEnoughContent = !!(source || children);
  if (!hasEnoughContent) return null;

  if (link?.href) {
    return (
      <Link className={`${CARD_BORDER_CLASSES} ${CARD_STYLE_CLASSES}`} href={link.href} variant="card">
        {source && (
          <Chip color="grey" size="small">
            {source}
          </Chip>
        )}
        {children}
        <FontAwesomeIconWrapper className="self-end mt-auto" icon={link.openInNewTab ? faArrowUpRightFromSquare : faArrowRight} style={{ color: "var(--design-color-icon-action-default)" }} size="lg" />
      </Link>
    );
  }

  return (
    <Card className={`${CARD_BORDER_CLASSES} ${CARD_STYLE_CLASSES}`}>
      {source && (
        <Chip color="grey" size="small">
          {source}
        </Chip>
      )}
      {children}
    </Card>
  );
}
